import type { BasicFilter } from './api';

export interface AggregationGroup {
  id: string;
  type: TemplateAggregationGroupType;
  name: string;
  attributes: AggregationGroupValue[];
}

export interface AggregationGroupValue {
  valueType: TemplateAggregationGroupValueType;
  order: number;
  templateDataItemId: number | null;
  staticValue: string | null;
}

export enum TemplateAggregationGroupValueType {
  Static = 'Static',
  Attribute = 'Attribute',
}

export enum TemplateAggregationGroupType {
  None = 'None',
  Sum = 'Sum',
  Count = 'Count',
  Avg = 'Avg',
  Min = 'Min',
  Max = 'Max',
  Concatenate = 'Concatenate',
}

export interface AggregationGroupsRes {
  items: AggregationGroup[];
  page: number;
  pageSize: number;
  totalCount: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface AggregationGroupsReq<T> extends BasicFilter<T> {
  id: string;
}
